import { connect } from "react-redux";

import RelatedEntitiesMatching from "@app/component/activity/RelatedEntitiesMatching";
import { RootState } from "@app/store/rootReducer";

import { isEntityRelating, isEntityRelatingSuccessful } from "../../store";
import { relateUnrelateEntities } from "../../store/actions";

const mapStateToProps = (state: RootState) => ({
  entityRelatingSuccess: isEntityRelatingSuccessful(state),
  isEntityRelating: isEntityRelating(state),
});

const mapDispatchToProps = {
  relateUnrelateEntities: relateUnrelateEntities.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(RelatedEntitiesMatching);
